var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-admin-wrap layout-sidebar-large clearfix"},[_c('top-nav'),_c('sidebar'),_c('main',[_c('div',{staticClass:"main-content-wrap d-flex flex-column",class:{ 'sidenav-open': _vm.getSideBarToggleProperties.isSideNavOpen }},[_c('transition',{attrs:{"name":"page","mode":"out-in"}},[_c('router-view')],1),_c('appFooter')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }